import { I18nProvider } from '@lingui/react';
import type { AnyRouter } from '@tanstack/react-router';
import { Fragment } from 'react';

import {
  RouterSsrLinguiOptions,
  setupCoreLinguiSsrIntegration,
} from './setupCoreLinguiSsrIntegration';

export type Options<TRouter extends AnyRouter> = RouterSsrLinguiOptions<TRouter> & {
  wrapQueryClient?: boolean;
};

export function setupLinguiSsrIntegration<TRouter extends AnyRouter>(opts: Options<TRouter>) {
  setupCoreLinguiSsrIntegration(opts);

  const OGWrap = opts.router.options.Wrap || Fragment;

  opts.router.options.Wrap = ({ children }) => {
    return (
      <I18nProvider i18n={opts.i18n}>
        <OGWrap>{children}</OGWrap>
      </I18nProvider>
    );
  };
}
